// removed by extract-text-webpack-plugin
module.exports = {"component":"_1QmLOpmDsa_5C9TqFImOcG","date":"yr-zDhLJ4QJbjC4Rz1ygh","month":"_1-gpaOKle8zIKPAgJLJgg4","timeOfDay":"_14tdBNTmxwBJGQYl_w6F4L"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Health/HealthRecordDate/HealthRecordDate.css
// module id = 1280
// module chunks = 0